import { GrupoFrotistaListagem } from '@sotran/lib-shipper';
import { Col, Row } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import SubHeader from '../../../components/SubHeader';
import { useAuth } from '../../../security/authContext';
import apiNetCore from '../../../services/apiNetCore';
import { Content, IncluirButton, Spin } from './styles';

const ListagemGrupoFrotista = () => {
  const history = useHistory();
  const { user } = useAuth();
  const [loading, setLoading] = useState(false);
  const [idCliente, setIdCliente] = useState();

  useEffect(() => {
    async function onInit() {
      setLoading(true);
      setIdCliente(user.cliente_tmov_id);
      setLoading(false);
    }

    onInit();
  }, []);

  const gotToNewGrup = () => history.push('/grupo-frotista/novo');

  const breadcrumbs = [
    {
      breadcrumbName: 'Cadastros',
    },
    {
      breadcrumbName: 'Grupo de Frotista',
    },
  ];
  return (
    <>
      <Spin size="large" spinning={loading}>
        <SubHeader breadcrumbs={breadcrumbs} />
        <Content>
          <Col span={24}>
            <Row gutter={[8, 16]} justify="end">
              <Col>
                <IncluirButton type="primary" onClick={gotToNewGrup}>
                  Criar grupo
                </IncluirButton>
              </Col>
            </Row>
            <GrupoFrotistaListagem
              history={history}
              setLoading={setLoading}
              apiNetCore={apiNetCore}
              idCliente={idCliente}
              goToEdit={idGrupoFrotista =>
                history.push(`/grupo-frotista/editar/${idGrupoFrotista}`)
              }
            />
          </Col>
        </Content>
      </Spin>
    </>
  );
};

export default ListagemGrupoFrotista;
